<template>
    <span>
        <span v-html="translatedText"></span>
        <span v-if="needTranslate">
            <a style="color: blue; cursor: pointer;" @click="translate" v-if="!isTranslated && !translate_now">translate</a>
            <span class="alert-danger" v-if="errorMessage">{{errorMessage}}</span>
        </span>
    </span>
</template>

<script>
    import axios from 'axios';
    import LaravelRouter from '../thirdparty/Ziggy/route.js';

    export default {
        props: [
            'text',
            'target_language',
            'translate_now'
        ],
        data() {
            return {
                translatedText: this.text,
                isTranslated: false,
                errorMessage: '',
                needTranslate: false,
                targetLanguage: (this.target_language) ? this.target_language : 'en'
            }
        },
        mounted(){
            this.checkNeedTranslate()
        },
        methods: {
            translate() {
                let route = LaravelRouter('translate');
                axios.get(route, {
                    params: {
                        text: this.text,
                        target_language: this.targetLanguage
                    }
                }).then(response => {
                    if (response && response.data) {
                        this.translatedText = response.data;
                        this.isTranslated = true;
                        this.errorMessage = '';
                    } else {
                        this.errorMessage = 'error';
                    }
                }).catch(errors => {
                    this.errorMessage = errors.response.data.message;
                });
            },

            checkNeedTranslate() {
                if (this.text) {
                    let route = LaravelRouter('detect-language');
                    axios.get(route, {
                        params: {
                            text: this.text,
                        }
                    }).then(response => {
                        if (response && response.data) {
                            this.needTranslate = this.targetLanguage !== response.data;
                            if (this.translate_now) {
                                this.translate()
                            }
                        }
                    })
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/TranslatableText.vue